import { observer } from "mobx-react";
import { Tournament, tournamentStore } from "../../Stores/tournamentStore";
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { CSSProperties, ReactNode, useEffect, useState } from "react";
import { Gamer } from "../../Model/gamer";
import { gamersStore } from "../../Stores/playersStore";
import { ControllerSelect } from "../../MiniComponents/controllerSelect";
import { ScorePicker } from "../Dialog/numberPicker";
import { Controller, ControllerType } from "../../Model/controller";
import { LiveScoreResult, liveScoreStore } from "../../Stores/liveScoreStore";
import axios from "axios";
import { AutoComplete } from "primereact/autocomplete";

import * as MUI from "@mui/material/Autocomplete";
import React from "react";
import { useParams } from "react-router";
import { accountingStore } from "../../Stores/acountingStore";
import { Pricing } from "../../Model/pricing";
import { authStore } from "../../App";

const _LiveScoreBoard: React.FC<{ tournament?: Tournament }> = ({
  tournament,
}) => {
  const [open, setOpen] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [homePlayer, setHomePlayer] = useState<Gamer | null>(null);
  const [awayPlayer, setAwayPlayer] = useState<Gamer | null>(null);
  const [homeScore, setHomeScore] = useState(0);
  const [awayScore, setAwayScore] = useState(0);
  const [homeController, setHomeController] = useState<Controller | null>(null);
  const [awayController, setAwayController] = useState<Controller | null>(null);
  const [pricingModel, setPricingModel] = useState<Pricing | undefined>(
    undefined,
  );
  const { id } = useParams();

  const [cType, setCType] = useState<ControllerType>(
    ControllerType.PLAYSTATION,
  );

  const scoreRecord = () => {
    if (authStore.focusedStore) {
      liveScoreStore.addScore({
        A_Player: awayPlayer?.nickname,
        away_goals: awayScore,
        away_player: awayPlayer?.uid,
        game_id: "gTAu65fmgHqdnGgan65q",
        H_Player: homePlayer?.nickname,
        home_goals: homeScore,
        home_player: homePlayer?.uid,
        id: "",
        tournament_id: tournament?.id,
        timestamp: new Date().toDateString(),
        liveDocID: "NEW_LIVE",
        pricing_id: "f1e7edd4-5e8d-11f0-962e-0a67fa16b369",
        store_id: authStore.focusedStore.storeId,
      } as LiveScoreResult);
    } else {
      alert("No Store selected");
    }
  };

  useEffect(() => {
    if (pricingModel === undefined) {
      console.log("defaulting pricing model");
      setPricingModel(accountingStore.pricingModels[0]);
    }
  }, [pricingModel]);

  return (
    <>
      <Button onClick={() => setOpen(true)}>New Scoreboard</Button>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              padding: 15,
              background: "transparent",
              display: "flex",
              flexFlow: "column",
              textAlign: "center",
            }}
          >
            <label
              style={{ textDecoration: "underline" }}
            >{`${tournament?.title} | EA Sports FC 26 - ${authStore.focusedStore?.storeName} (store)`}</label>
            <Select
              onChange={(e) => {
                console.log(`Selected Pricing Model`, e.target.value);
                const v = e.target.value as string;
                setPricingModel(
                  accountingStore.pricingModels.find((i) => i.id === v),
                );
              }}
            >
              {accountingStore.pricingModels.map((w) => (
                <MenuItem value={w.id}>
                  {`${w.description} `} &mdash; {`R ${w.value} p.p / p.g`}
                </MenuItem>
              ))}
            </Select>
            <div style={{ display: "flex", flexFlow: "row" }}>
              <div
                key={"home"}
                style={{ width: "40%", display: "flex", flexFlow: "column" }}
              >
                <h1>Home</h1>
                <GamerSelector
                  onSelectChange={(selected) => {
                    console.log(selected);
                    setHomePlayer(selected);
                  }}
                />
                <label
                  style={{
                    padding: "10px",
                    background: homePlayer
                      ? "rgba(0,0.6,0,0.4)"
                      : "transparent",
                  }}
                >
                  {homePlayer ? `Credit: R ${homePlayer.credit_balance}` : ``}
                </label>
                Controller
                <ControllerSelect
                  cType={cType}
                  onSelected={(v) => {
                    console.log(v);
                    setHomeController(v);
                  }}
                />
                <ScorePicker
                  onChange={(v) => {
                    setHomeScore(v);
                  }}
                />
              </div>
              <div style={{ width: "20%" }}>VS</div>
              <div
                key={"away"}
                style={{ width: "40%", display: "flex", flexFlow: "column" }}
              >
                <h1>Away</h1>
                <GamerSelector
                  onSelectChange={(selected) => {
                    console.log(selected);
                    setAwayPlayer(selected);
                  }}
                />
                <label
                  style={{
                    padding: "10px",
                    background: awayPlayer
                      ? "rgba(0,0.6,0,0.4)"
                      : "transparent",
                  }}
                >
                  {awayPlayer ? `Credit: R ${awayPlayer?.credit_balance}` : ``}
                </label>
                Controller
                <ControllerSelect
                  cType={cType}
                  onSelected={(v) => {
                    console.log(v);
                    setAwayController(v);
                  }}
                />
                <ScorePicker
                  onChange={(v) => {
                    setAwayScore(v);
                  }}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexFlow: "row",
              justifyItems: "center",
              background: "whitesmoke",
              borderRadius: 25,
            }}
          >
            <label style={{ padding: 20, textAlign: "center" }}>
              Please ensure both players have paid before you click{" "}
              <b>Save Results</b>
            </label>
          </div>

          <Button onClick={scoreRecord}>Save Results</Button>
        </Box>
      </Modal>
    </>
  );
};
const GamerSelector: React.FC<{
  onSelectChange: (selected: Gamer | null) => void;
}> = ({ onSelectChange }) => {
  const [gamer, setGamer] = useState<Gamer | null>(null);
  const [gamers, setGamers] = useState<Gamer[]>([]);
  const [stringifiedValue, setStringifiedValue] = useState("");
  const [playerID, setPlayerID] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const applySearch = (key: string) => {
    setLoading(true);
    axios
      .get(`https://wallof-backend.uc.r.appspot.com/player/search/${key}`)
      .then((v) => {
        setLoading(false);
        console.log(v.data);
        const foundPlayers = v.data as Gamer[];
        setGamers(foundPlayers);
        console.log(foundPlayers);
      })
      .catch((e) => {
        setLoading(false);
        console.error(e);
      });
  };

  const itemStyle = {
    display: "flex",
    flexFlow: "column",
  } as CSSProperties;

  useEffect(() => {
    if (gamer) {
      console.log(gamer);
      onSelectChange(gamer);
    }
    // if (playerID) {
    //   applySearch(playerID);
    // }
  }, [gamer, playerID]);
  return (
    <Autocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={gamers}
      loading={loading}
      getOptionLabel={(g) => g.nickname}
      onInputChange={(rE, val, reason) => {
        const v = rE.target as unknown as any;
        const value = v["value"];
        console.log("onInputChange", value);
        if (reason === "input") {
          // setPlayerID(val);
          applySearch(val);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Player ID/Nickname"
          value={playerID}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <label>-</label> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          onChange={(e) => {
            const v = e.target as unknown as any;
            const val = v["value"];
            setPlayerID(val);
          }}
        />
      )}
      renderOption={(option, gamer) => {
        const { key, ...optionProps } = option;

        option.id = gamer.uid;
        optionProps.id = gamer.uid;
        option.key = gamer.uid;

        return (
          <Box
            style={itemStyle}
            key={gamer.uid}
            id={gamer.uid}
            component={"li"}
            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
            {...optionProps}
          >
            <label style={{ fontSize: "10px" }} key={gamer.uid}>
              {gamer.uid}
            </label>
            <label style={{ fontSize: "15px" }} key={gamer.nickname}>
              {gamer.nickname}
            </label>
          </Box>
        );
      }}
      id="player-key-autocomplete"
      onChange={(e) => {
        const keyValue = e.currentTarget as unknown as any;

        console.log(`onChange => `, keyValue);
        const id = keyValue["id"]; //this is the UID of the player
        const selectedGamer = gamers.find((g) => g.uid === id);
        if (selectedGamer) {
          console.log(`Selected Gamer`, selectedGamer);
          setGamer(selectedGamer);
          onSelectChange(selectedGamer);
        }
      }}
    />
  );
};

export const LiveScoreBoard = observer(_LiveScoreBoard);
